export enum CREATE_REPORT_SECTION {
    DATASOURCE,
    FIELDS,
    FILTERS,
    MISC
}